import React from 'react';
import NavBar from '../components/navbar';
import Footer from '../components/footer';
import "../styles/responsive.css"
import bg from "../images/About_us_background.png"
import image from "../images/Laroye_Logo-WORKING_Icon-B.svg"

const Home = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', overflowX: 'hidden' }}>
      <NavBar />
    
      <section style={{ overflowY:'hidden', position: 'relative',  backgroundImage: `url(${bg})`, backgroundPosition: 'center', backgroundSize: '160%', height: '100vh', backgroundRepeat: 'no-repeat', backgroundColor: "#ebb556" }}>
      <div className='aboutContainer' >
      <div style={{flex: '2'}} >
        <p style={hd2}>
          Laroye is a pioneering company at the intersection of artificial intelligence and youth empowerment.
          We are dedicated to creating AI solutions that enhance the social and mental well-being of young
          adults. <br/><br/>Our unique name, derived from the West African term meaning "that which helps one to
          understand," reflects our commitment to clarity and insight in the digital age.<br/><br/> By harnessing the
          potential of AI, we aim to unfold a new era where technology guides individuals under 26 towards
          achieving their life aspirations and thriving in their social environments.
        </p><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        </div>    <div style={{ flex: '1', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <img style={{ maxWidth: '140%', marginRight:"24%", scale:"1.4", marginBottom:"15%",zIndex:"0" }} src={image} alt="" />
  </div>
        </div></section>
   
  
      <Footer />
    </div>
  );
};

const hd1 = {
  fontFamily: 'Poppins',
  fontStyle: 'italic',
  margin: "2%",
  color: 'white',
  marginLeft: "7%",
}

const hd2 = {
  marginTop:'7%',
  justifyContent:"center",
  fontStyle: 'italic',
  alignItems:"center",
  fontFamily: 'Poppins',
  marginRight: '20%',
  marginLeft: '5%',
  color: 'white',
  textAlign: 'left'
}

export default Home;
